import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4f3d2655"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/_createTextVNode(" この病院で実習した皆さん、 口コミを書いてみませんか？ ")
const _hoisted_2 = /*#__PURE__*/_createTextVNode("口コミを投稿")
const _hoisted_3 = { class: "title" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { id: "interview" }, "従業員インタビュー", -1))
const _hoisted_5 = ["id"]
const _hoisted_6 = { style: {"text-align":"center"} }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = ["src"]
const _hoisted_9 = {
  key: 2,
  class: "interviewImage"
}
const _hoisted_10 = { style: {"font-size":"1.05rem"} }
const _hoisted_11 = { class: "interviewRating" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("b", null, "評価")
], -1))
const _hoisted_13 = { class: "horizontal" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "interviewLabel" }, "仕事のやりがい", -1))
const _hoisted_15 = { class: "horizontal" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "interviewLabel" }, "スキルアップ度", -1))
const _hoisted_17 = { class: "horizontal" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "interviewLabel" }, "労働環境", -1))
const _hoisted_19 = { class: "horizontal" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "interviewLabel" }, "院内の雰囲気", -1))
const _hoisted_21 = { class: "horizontal" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "interviewLabel" }, "給与水準", -1))
const _hoisted_23 = { style: {"width":"calc(100% - 20rem)","padding":"1rem","min-width":"300px"} }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("b", null, "この病院を入社した理由を教えてください")
], -1))
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("b", null, "貴院の強みは何ですか")
], -1))
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("b", null, "学生のうちにやっておけばいいと思うことは何ですか")
], -1))
const _hoisted_27 = {
  key: 1,
  style: {"max-width":"500px"}
}
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { id: "interview" }, "従業員インタビュー", -1))
const _hoisted_29 = {
  class: "horizontal",
  style: {"align-items":"center"},
  id: "review"
}
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { id: "review" }, "口コミ", -1))
const _hoisted_31 = { class: "loginedReviewBtn" }
const _hoisted_32 = /*#__PURE__*/_createTextVNode("口コミを投稿")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Header = _resolveComponent("Header")!
  const _component_n_button = _resolveComponent("n-button")!
  const _component_n_divider = _resolveComponent("n-divider")!
  const _component_no_image = _resolveComponent("no-image")!
  const _component_n_icon = _resolveComponent("n-icon")!
  const _component_n_empty = _resolveComponent("n-empty")!
  const _component_n_rate = _resolveComponent("n-rate")!
  const _component_budou_x = _resolveComponent("budou-x")!
  const _component_Review = _resolveComponent("Review")!
  const _component_n_layout = _resolveComponent("n-layout")!
  const _component_n_skeleton = _resolveComponent("n-skeleton")!
  const _component_n_space = _resolveComponent("n-space")!

  return (_openBlock(), _createBlock(_component_n_space, {
    vertical: "",
    style: {"padding":"10px"}
  }, {
    default: _withCtx(() => [
      _createVNode(_component_Header),
      (_ctx.hospital.id)
        ? (_openBlock(), _createBlock(_component_n_layout, {
            key: 0,
            style: {"padding":"10px"},
            ref: "content"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", null, [
                _hoisted_1,
                _createVNode(_component_n_button, {
                  quaternary: "",
                  type: "primary",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push(`/my/review/edit?hospitalId=${_ctx.hospital.id}`)))
                }, {
                  default: _withCtx(() => [
                    _hoisted_2
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.hospital.name), 1),
              _createElementVNode("p", null, "住所: " + _toDisplayString(_ctx.hospital.addressDetails), 1),
              _createVNode(_component_n_divider),
              (_ctx.interviews.length)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _hoisted_4,
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.interviews, (interview) => {
                      return (_openBlock(), _createElementBlock("div", {
                        class: "interview horizontal",
                        key: interview.id,
                        id: `interview_${interview.id}`
                      }, [
                        _createElementVNode("div", _hoisted_6, [
                          (interview.status !== 'accepted')
                            ? (_openBlock(), _createElementBlock("b", _hoisted_7, "このインタビューはまだ公開されていません"))
                            : _createCommentVNode("", true),
                          (interview.photo)
                            ? (_openBlock(), _createElementBlock("img", {
                                key: 1,
                                class: "interviewImage",
                                src: interview.photo,
                                alt: "インタビュアーの写真"
                              }, null, 8, _hoisted_8))
                            : (_openBlock(), _createElementBlock("div", _hoisted_9, [
                                _createVNode(_component_n_empty, {
                                  description: "Now Printing",
                                  size: "huge"
                                }, {
                                  icon: _withCtx(() => [
                                    _createVNode(_component_n_icon, null, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_no_image)
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                })
                              ])),
                          _createElementVNode("p", _hoisted_10, [
                            _createElementVNode("b", null, _toDisplayString(interview.name), 1),
                            _createTextVNode("(" + _toDisplayString(_ctx.getJobType(interview.jobtype)) + ") ", 1)
                          ]),
                          _createElementVNode("div", _hoisted_11, [
                            _hoisted_12,
                            _createElementVNode("div", _hoisted_13, [
                              _hoisted_14,
                              _createVNode(_component_n_rate, {
                                readonly: "",
                                "default-value": interview.option1[0]
                              }, null, 8, ["default-value"])
                            ]),
                            _createElementVNode("div", _hoisted_15, [
                              _hoisted_16,
                              _createVNode(_component_n_rate, {
                                readonly: "",
                                "default-value": interview.option1[1]
                              }, null, 8, ["default-value"])
                            ]),
                            _createElementVNode("div", _hoisted_17, [
                              _hoisted_18,
                              _createVNode(_component_n_rate, {
                                readonly: "",
                                "default-value": interview.option1[2]
                              }, null, 8, ["default-value"])
                            ]),
                            _createElementVNode("div", _hoisted_19, [
                              _hoisted_20,
                              _createVNode(_component_n_rate, {
                                readonly: "",
                                "default-value": interview.option1[3]
                              }, null, 8, ["default-value"])
                            ]),
                            _createElementVNode("div", _hoisted_21, [
                              _hoisted_22,
                              _createVNode(_component_n_rate, {
                                readonly: "",
                                "default-value": interview.option1[4]
                              }, null, 8, ["default-value"])
                            ])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_23, [
                          _hoisted_24,
                          _createElementVNode("p", null, [
                            _createVNode(_component_budou_x, null, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(interview.option2), 1)
                              ]),
                              _: 2
                            }, 1024)
                          ]),
                          _hoisted_25,
                          _createElementVNode("p", null, [
                            _createVNode(_component_budou_x, null, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(interview.option3), 1)
                              ]),
                              _: 2
                            }, 1024)
                          ]),
                          _hoisted_26,
                          _createElementVNode("p", null, [
                            _createVNode(_component_budou_x, null, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(interview.option4), 1)
                              ]),
                              _: 2
                            }, 1024)
                          ])
                        ])
                      ], 8, _hoisted_5))
                    }), 128))
                  ], 64))
                : (_openBlock(), _createElementBlock("div", _hoisted_27, [
                    _hoisted_28,
                    _createVNode(_component_n_empty, { description: "インタビューはありません" })
                  ])),
              _createElementVNode("div", _hoisted_29, [
                _hoisted_30,
                _createElementVNode("div", _hoisted_31, [
                  _createVNode(_component_n_button, {
                    size: "large",
                    type: "primary",
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$router.push(`/my/review/edit?hospitalId=${_ctx.hospital.id}`)))
                  }, {
                    default: _withCtx(() => [
                      _hoisted_32
                    ]),
                    _: 1
                  })
                ])
              ]),
              _createVNode(_component_Review, { reviews: _ctx.reviews }, null, 8, ["reviews"])
            ]),
            _: 1
          }, 512))
        : (_openBlock(), _createBlock(_component_n_space, {
            key: 1,
            vertical: "",
            style: {"background-color":"white","padding":"10px"}
          }, {
            default: _withCtx(() => [
              _createVNode(_component_n_skeleton, {
                height: "40px",
                width: "33%"
              }),
              _createVNode(_component_n_skeleton, {
                height: "140px",
                width: "66%",
                sharp: false
              })
            ]),
            _: 1
          }))
    ]),
    _: 1
  }))
}